module.exports = __webpack_public_path__ + "img/2023-----1-----@1x.aa9c7599.png";